const AppDialogPlayerEvent = {};
export default AppDialogPlayerEvent;

AppDialogPlayerEvent.SKIP_DIALOG_OPTION = "AppDialogPlayerEvent.SKIP_DIALOG_OPTION";